import script from "./DetailsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsCard.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/card-rizz.css?vue&type=style&index=0&id=2bc7a1d3&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc7a1d3"]])

export default __exports__